import { Component } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { LoadingController } from "@ionic/angular";
import { IframePage } from "../iframe/iframe.page";

@Component({
  selector: "app-postpone-check-out",
  templateUrl: "../iframe/iframe.page.html",
  styleUrls: ["../iframe/iframe.page.scss"],
})
export class PostponeCheckUpPage extends IframePage {
  constructor(protected _store: Store<RootState>, protected _loadingController: LoadingController, private sanitizer: DomSanitizer) {
    super(_store, _loadingController);
    this.title = "Check-Up verschieben";
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://hilfe.wowfamily.de/check-up-termin-verschieben-oder-absagen");
  }
}
